// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sm-0";